import { useEffect, useState } from "react";

import { WebSocketComponent } from "components";
import { usePermanentSession } from "modules/Login/hooks";
import { checkForNewAppVersion } from "utils/common";

let timeoutId = 0;

export const useIsSessionExpired = () => {
  const [isSessionExpired, setIsSessionExpired] = useState(false);

  const { session } = usePermanentSession();

  const handleSessionExpiration = () => {
    WebSocketComponent.disconnect();
    setIsSessionExpired(true);
  };

  const setSessionExpirationTimeout = async () => {
    if (!session?.expire_at) return;

    clearTimeout(timeoutId);

    const expireAt = new Date(session.expire_at).getTime();
    if (expireAt <= Date.now()) {
      handleSessionExpiration();
      return;
    }

    if (isSessionExpired) {
      const hasNewAppVersion = await checkForNewAppVersion();

      if (hasNewAppVersion) {
        document.location.reload();
        return;
      }
    }

    timeoutId = window.setTimeout(handleSessionExpiration, Math.max(0, expireAt - Date.now()));
    setIsSessionExpired(false);
  };

  const handleVisibilityChange = () => {
    clearTimeout(timeoutId);
    if (!document.hidden) setSessionExpirationTimeout();
  };

  useEffect(() => {
    setSessionExpirationTimeout();

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [session]);

  return isSessionExpired;
};
